/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "L\xF8rdag", "S\xF8ndag"], a = ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"], t = "\xC5r (flertal)", d = "\xC5r", n = "M\xE5ned", r = "Uge", s = "Dag", g = "I dag", l = "Ingen begivenhed", o = "Hele dagen", M = "Slet", v = "Opret et event", y = "dddd D MMMM YYYY", m = { weekDays: e, months: a, years: "\xC5r (flertal)", year: "\xC5r", month: "M\xE5ned", week: "Uge", day: "Dag", today: "I dag", noEvent: "Ingen begivenhed", allDay: "Hele dagen", deleteEvent: "Slet", createEvent: "Opret et event", dateFormat: "dddd D MMMM YYYY" };
export {
  o as allDay,
  v as createEvent,
  y as dateFormat,
  s as day,
  m as default,
  M as deleteEvent,
  n as month,
  a as months,
  l as noEvent,
  g as today,
  r as week,
  e as weekDays,
  d as year,
  t as years
};
